"use client";
import React, { memo, forwardRef } from "react";
import Cropper, { ReactCropperProps, ReactCropperElement } from "react-cropper";
import "cropperjs/dist/cropper.css";
import { AppConstant } from "@/const";

const AppCropImage = forwardRef<ReactCropperElement, ReactCropperProps>(
  ({ ...otherProps }: ReactCropperProps, ref) => {
    return (
      <Cropper
        style={{ height: 600, width: "100%" }}
        aspectRatio={AppConstant.IMAGE_RATIO}
        guides={true}
        ref={ref}
        viewMode={1}
        zoomOnTouch={false}
        rotatable={false}
        {...otherProps}
      />
    );
  }
);
AppCropImage.displayName = "AppCropImage";
export default memo(AppCropImage);
